import { getValueByPath } from './helpers.js';
import { B as BaseComponentMixin, c as config, f as VueComponentMixin, e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import './Icon-4445210d.js';
import { resolveComponent, openBlock, createBlock, createVNode, Fragment, renderList, withDirectives, createCommentVNode, toDisplayString, vShow, renderSlot } from 'vue';
import './SlotComponent-0709556c.js';
import { T as TabbedMixin, a as TabbedChildMixin } from './TabbedChildMixin-ca46729a.js';

/**
 * Responsive horizontal navigation tabs, switch between contents with ease
 * @displayName Tabs
 * @requires ./TabItem.vue
 * @example ./examples/Tabs.md
 * @style _tabs.scss
 */

var script = {
  name: 'OTabs',
  mixins: [BaseComponentMixin, TabbedMixin('tab')],
  props: {
    /**
     * Tab type
     * @values boxed, toggle
     */
    type: [String, Object],

    /**
    * Tabs will be expanded (full-width)	
    */
    expanded: Boolean,

    /** Tab will have an animation */
    animated: {
      type: Boolean,
      default: () => {
        return getValueByPath(config, 'tabs.animated', true);
      }
    },

    /** Show tab items multiline when there is no space */
    multiline: Boolean,
    rootClass: String,
    positionWrapperClass: String,
    expandedWrapperClass: String,
    verticalWrapperClass: String,
    multilineWrapperClass: String,
    tabsClass: String,
    typeClass: String,
    sizeClass: String,
    positionClass: String,
    contentClass: String,
    transitioningClass: String,
    tabItemHeaderActiveClass: String,
    tabItemHeaderDisabledClass: String
  },
  computed: {
    rootClasses() {
      return [this.computedClass('tabs', 'rootClass', 'o-tabs-wrapper'), {
        [`${this.computedClass('tabs', 'positionWrapperClass', 'o-tabs-wrapper-position-')}${this.position}`]: this.position && this.vertical
      }, {
        [this.computedClass('tabs', 'expandedWrapperClass', 'o-tabs-wrapper-fullwidth')]: this.expanded
      }, {
        [this.computedClass('tabs', 'verticalWrapperClass', 'o-tabs-wrapper-vertical')]: this.vertical
      }, {
        [this.computedClass('tabs', 'multilineWrapperClass', 'o-tabs-wrapper-multiline')]: this.multiline
      }];
    },

    navClasses() {
      return [this.computedClass('tabs', 'tabsClass', 'o-tabs'), {
        [`${this.computedClass('tabs', 'typeClass', 'o-tabs-')}${this.type}`]: this.type
      }, {
        [`${this.computedClass('tabs', 'sizeClass', 'o-size-')}${this.size}`]: this.size
      }, {
        [`${this.computedClass('tabs', 'positionClass', 'o-tabs-position-')}${this.position}`]: this.position && !this.vertical
      }];
    },

    contentClasses() {
      return [this.computedClass('tabs', 'contentClass', 'o-tab-content'), {
        [this.computedClass('tabs', 'transitioningClass', 'o-tab-content-transitioning')]: this.isTransitioning
      }];
    }

  }
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_o_slot_component = resolveComponent("o-slot-component");
  const _component_o_icon = resolveComponent("o-icon");

  return (_ctx.vueReady)
    ? (openBlock(), createBlock("div", {
        key: 0,
        class: $options.rootClasses
      }, [
        createVNode("nav", { class: $options.navClasses }, [
          createVNode("ul", null, [
            (openBlock(true), createBlock(Fragment, null, renderList(_ctx.items, (childItem) => {
              return withDirectives((openBlock(), createBlock("li", {
                key: childItem.newValue,
                class: childItem.headerClasses
              }, [
                (childItem.hasHeaderSlot)
                  ? createVNode(_component_o_slot_component, {
                      key: 0,
                      component: childItem,
                      name: "header",
                      tag: "button",
                      onClick: $event => (_ctx.childClick(childItem))
                    }, null, 8 /* PROPS */, ["component", "onClick"])
                  : (openBlock(), createBlock("button", {
                      key: 1,
                      onClick: $event => (_ctx.childClick(childItem))
                    }, [
                      (childItem.icon)
                        ? createVNode(_component_o_icon, {
                            key: 0,
                            icon: childItem.icon,
                            pack: childItem.iconPack,
                            size: _ctx.size
                          }, null, 8 /* PROPS */, ["icon", "pack", "size"])
                        : createCommentVNode("v-if", true),
                      createVNode("span", null, toDisplayString(childItem.label), 1 /* TEXT */)
                    ], 8 /* PROPS */, ["onClick"]))
              ], 2 /* CLASS */)), [
                [vShow, childItem.visible]
              ])
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */),
        createVNode("section", { class: $options.contentClasses }, [
          renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */)
      ], 2 /* CLASS */))
    : createCommentVNode("v-if", true)
}

script.render = render;
script.__file = "oruga/src/components/tabs/Tabs.vue";

/**
 * @displayName Tab Item
 */

var script$1 = {
  name: 'OTabItem',
  mixins: [VueComponentMixin(), BaseComponentMixin, TabbedChildMixin('tab')],
  props: {
    /** Item will be disabled */
    disabled: Boolean,
    itemClass: String,
    itemHeaderActiveClass: String,
    itemHeaderDisabledClass: String
  },
  computed: {
    elementClasses() {
      return [this.computedClass('tabs', 'itemClass', 'o-tab-item')];
    },

    headerClasses() {
      return [this.headerClass, {
        [this.computedClass('tabs', 'itemHeaderActiveClass', 'o-tab-active')]: this.isActive
      }, {
        [this.computedClass('tabs', 'itemHeaderDisabledClass', 'o-tab-disabled')]: this.disabled
      }];
    },

    hasHeaderSlot() {
      return this.existsSlot('header');
    }

  }
};

script$1.__file = "oruga/src/components/tabs/TabItem.vue";

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
    registerComponent(Vue, script$1);
  }

};
use(Plugin);

export default Plugin;
export { script$1 as OTabItem, script as OTabs };
